// extracted by mini-css-extract-plugin
export default {"wrapper":"wZVBhZU7L1zHHgtr1YcS","title":"_gcDxlBQArrsKw3qtYd4","content":"C7jMF9KIaDp7BM73Jj77"};